import { useLayoutEffect, useState } from 'react';

export type RectResult = {
  bottom: number | string;
  height: number | string;
  left: number | string;
  right: number | string;
  top: number | string;
  width: number | string;
};

function getRect<T extends HTMLElement>(element?: T): RectResult {
  let rect: RectResult = {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
  };

  if (element) rect = element.getBoundingClientRect();
  return rect;
}

export default function useRect<T extends HTMLElement>(
  ref?: React.RefObject<T> | null,
  update?: boolean,
): RectResult {
  const [rect, setRect] = useState<RectResult>(
    ref && ref.current ? getRect(ref.current) : getRect(),
  );

  useLayoutEffect(() => {
    const element = ref && ref.current;

    if (!element) return;

    setRect(getRect(element)); // Update client rect
  }, [ref, update]);

  return rect;
}
